/*
 * TasksPage.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { localization } from '../../../config/localize/localizable'
import { useTaskHooks } from '../hooks/useTaskHooks'

import Pagination from 'rc-pagination'
import DeleteModal from '../../../component/general/DeleteMoal'
import { toast } from 'react-hot-toast'
import { getPermissions } from '../../../config/constant/constants'
import { MenuName } from '../../../config/menu/MenuName'
import SimpleTableHeaders from '../../../component/element/Table/SimpleTableHeader'
import SimpleTableCells from '../../../component/element/Table/SimpleTableCells'
import DateTableCells from '../../../component/element/Table/DateTableCells'
import SimpleActionTableCells from '../../../component/element/Table/SimpleActionTableCells'
import SimplePageTitle from '../../../component/general/SimplePageTitle'
import SimpleSearch from '../../../component/general/SimpleSearch'

const TasksPage = () => {
    //
    // MARK: VARIABLE
    const [pi, setPi] = useState(0)
    let ps = 20
    let order = 'desc'
    let field = 'id'
    const [query, setQuery] = useState('')
    const [totalItems, setTotalItems] = useState(0)
    const [models, setModels] = useState([])
    const [showDeleteModal, setShowDeleteModal] = useState(true)
    const [deletedItem, setDeletedItem] = useState({})
    const navigate = useNavigate()
    const service = useTaskHooks()

    //
    // MARK: METHODS

    useEffect(() => {
        if (getPermissions().filter((x) => x.menuTitle.toLowerCase() === MenuName.task.toLowerCase()).length === 0) navigate('/')
        getAll()
    }, [])

    const getAll = async (pi) => {
        await service.get(
            { pi, ps, order, field },
            {
                onSuccess: (result) => {
                    setTotalItems(result.data.totalPages * ps)
                    setModels(result.data.results)
                },
            }
        )
    }
    const search = async (pi, query) => {
        service.search(
            { pi, query },
            {
                onSuccess: async (result) => {
                    setTotalItems(result.data.totalPages * ps)
                    setModels(result.data.results)
                },
            }
        )
    }

    const handledbClick = (model) => {
        navigate(`${model.id}`, { state: { model } })
    }

    const handleEdit = (e, model) => {
        handledbClick(model)
    }

    const handleDelete = (e, model) => {
        setDeletedItem(model)
        setShowDeleteModal(false)
    }

    const handleSearch = (e) => {
        setPi(0)
        setQuery(e)
        if (e.length > 1) {
            setModels([])
            setTotalItems(0)
            search(0, e)
        } else if (e.length === 0) getAll(0)
    }

    const onPaginationChange = (page) => {
        if (page - 1 !== pi) {
            setPi(page - 1)
            if (query.length > 1) {
                setModels([])
                setTotalItems(page - 1)
                search(page - 1, query)
            } else if (query.length === 0) getAll(page - 1)
        }
    }
    return (
        <>
            <div className="col-span-3 ">
                <SimplePageTitle title={localization.task} />

                <div className="w-full ">
                    <div className="col-span-4  bg-white mt-3 ml-2 p-1 shadow-sm rounded-md">
                        <div className="grid grid-cols-3 col-span-4 text-right ml-2 ">
                            <div className="col-span-2 text-right px-2 justify-end ">
                                <SimpleSearch completion={(e) => handleSearch(e)} />
                            </div>
                            <div className="col-span-1 text-left">
                                <button className=" bg-green-700 hover:bg-green-800 text-white p-2 w-24 m-2 rounded shadow-sm" onClick={() => navigate('0')}>
                                    + {localization.add}
                                </button>
                            </div>
                        </div>
                        <table className="w-full p-2 bg-white text-center  rounded">
                            <thead className="h-10  bg-table-header text-xs rounded">
                                <tr>
                                    <SimpleTableHeaders items={[localization.number, localization.title, localization.platform, localization.date, localization.actions]} />
                                </tr>
                            </thead>
                            <tbody>
                                {models &&
                                    models.map((item, index) => {
                                        return (
                                            <tr className={`text-sm p-8 h-12 hover:bg-orange-50 border-b border-blue-100 ${index % 2 === 0 ? '' : 'bg-gray-50'}`} key={index} onDoubleClick={() => handledbClick(item)}>
                                                <SimpleTableCells items={[pi * ps + (index + 1), item.title, item.platform]} />
                                                <DateTableCells items={[item.registerDate]} />
                                                <SimpleActionTableCells item={item} handleEdit={(e) => handleEdit(e, item)} handleDelete={(e) => handleDelete(e, item)} />
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                        <div className="pt-4 mb-3">
                            <Pagination className="ant-pagination" onChange={onPaginationChange} current={pi + 1} total={totalItems} defaultPageSize={ps} />
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <DeleteModal
                    visible={showDeleteModal}
                    title={deletedItem.title}
                    complete={(flag) => {
                        setShowDeleteModal(true)
                        if (flag)
                            service.deleted(deletedItem.id, {
                                onSuccess: async (response) => {
                                    getAll()
                                    if (response?.data?.messages?.length > 0) toast.success(response?.data?.messages[0])
                                },
                            })
                    }}
                />
            </div>
        </>
    )
}

export default TasksPage
